import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Shell = ({ title, children, testId }) => {
    const navigate = useNavigate();
    const back = () => { if (window.history.length > 1) navigate(-1); else navigate("/"); };
    return (
        <div className="fixed inset-0 bg-black max-w-[480px] mx-auto flex flex-col" data-testid={testId}>
            <div className="shrink-0 safe-top flex items-center gap-3 px-4 py-3" style={{ borderBottom: "1px solid var(--border)" }}>
                <button data-testid="legal-back" onClick={back} className="tap-feedback w-9 h-9 flex items-center justify-center rounded-full" style={{ background: "var(--surface)" }}>
                    <ArrowLeft size={18} className="text-white" />
                </button>
                <h1 className="font-display font-black uppercase text-white" style={{ fontSize: 20 }}>{title}</h1>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto scrollbar-none px-5 py-5 safe-bottom legal-body">
                {children}
            </div>
        </div>
    );
};

const P = ({ children }) => <p className="font-body" style={{ fontSize: 14, lineHeight: 1.6, color: "var(--text-secondary)", marginBottom: 12, whiteSpace: "pre-line" }}>{children}</p>;
const H = ({ children }) => <p className="font-display font-black uppercase text-white" style={{ fontSize: 15, marginTop: 18, marginBottom: 6 }}>{children}</p>;
const Small = ({ children }) => <p className="font-body" style={{ fontSize: 12, color: "var(--text-secondary)", marginBottom: 14 }}>{children}</p>;

export const MentionsLegales = () => (
    <Shell title="Mentions légales" testId="page-mentions-legales">
        <Small>Dernière mise à jour : 27 septembre 2026</Small>
        <H>Éditeur du site glowupia.com</H>
        <P>{`[sekou Flenory]
Adresse : [Rue de Rivoli 576 Paris 75001]
Numéro d'entreprise : [123 455 999]
E-mail : glowupia2026@gmail.com
Responsable de la publication : [sekou Flenory)
Hébergement : Emergent (emergent.sh),`}</P>
        <H>Propriété intellectuelle</H>
        <P>le nom Glow Up IA, le logo, les textes, le design et le code du site sont protégés. Toute reproduction sans autorisation est interdite.</P>
    </Shell>
);

export const CGV = () => (
    <Shell title="CGV" testId="page-cgv">
        <Small>Conditions générales de vente
Dernière mise à jour : 27 septembre 2026</Small>
        <H>1. Le service</H>
        <P>Glow Up IA (glowupia.com) est un service en ligne édité par la personne indiquée dans les Mentions légales. Il analyse ton apparence à partir d'une photo et d'un questionnaire, te donne un score d'attirance et te propose un coach IA, Mike, ainsi que des plans personnalisés.</P>
        <H>2. Nature des résultats</H>
        <P>Les analyses, scores et conseils sont générés par intelligence artificielle. Ils sont indicatifs et subjectifs, et ne remplacent aucun avis médical, psychologique ou professionnel. Aucun résultat n'est garanti.</P>
        <H>3. Offres et prix</H>
        <P>{`Prix en euros, toutes taxes éventuelles comprises.
- Mensuel : 9,99 € le premier mois, puis 14,99 € par mois.
- Annuel : 99,99 € par an.
- Chaque abonnement inclut 2 analyses et 20 crédits par mois.
- Packs de crédits : 50 crédits pour 7,99 €, 100 crédits pour 9,99 €. Montant libre à partir de 20 crédits, prix total affiché avant le paiement.
Les crédits servent à échanger avec Mike et à générer des plans. Ils n'ont aucune valeur monétaire et ne sont ni remboursables ni échangeables.`}</P>
        <H>4. Paiement et renouvellement</H>
        <P>Le paiement est sécurisé par Stripe. L'abonnement se renouvelle automatiquement à chaque échéance, au prix indiqué ci-dessus, jusqu'à sa résiliation.</P>
        <H>5. Résiliation</H>
        <P>Tu peux résilier à tout moment depuis la page Compte. La résiliation prend effet à la fin de la période en cours, qui n'est pas remboursée.</P>
        <H>6. Droit de rétractation</H>
        <P>Ton analyse est accessible immédiatement après le paiement. Lors du paiement, tu demandes expressément cette exécution immédiate et tu reconnais perdre ton droit de rétractation de 14 jours dès l'accès à ton analyse complète.</P>
        <H>Conditions de remboursement</H>
        <P>Satisfait ou remboursé : uniquement pour les abonnements au tarif normal (14,99€). Si tu n'es pas satisfait, tu peux demander le remboursement entre 48h et 72h après ton paiement, le temps de tester réellement le service.</P>
        <P>{`Aucun remboursement n'est possible :
• pour les abonnements pris avec une offre promotionnelle (dont le tarif à 9,99€),
• pour toute demande envoyée avant 48h après le paiement (elle n'est pas prise en compte),
• pour toute demande envoyée plus de 72h après le paiement,
• pour les renouvellements d'abonnement : seul le premier paiement est concerné, et il t'appartient d'annuler avant la date de renouvellement.`}</P>
        <P>Demande à envoyer entre 48h et 72h après le paiement à glowupia2026@gmail.com</P>
        <H>7. Règles d'utilisation</H>
        <P>Tu n'envoies que des photos de toi. Sont interdits : les photos d'autres personnes sans leur accord et tout contenu illégal ou choquant. Un compte peut être suspendu en cas d'abus.</P>
        <H>8. Responsabilité</H>
        <P>Nous faisons le maximum pour que le service soit disponible, sans pouvoir garantir un accès continu. Tu restes seul responsable de l'usage que tu fais des résultats et des conseils.</P>
        <H>9. Données personnelles</H>
        <P>Voir la Politique de confidentialité.</P>
        <H>10. Litiges</H>
        <P>Ces conditions sont soumises au droit [FRANÇAIS], sans te priver des protections obligatoires de ton pays de résidence. En cas de problème, écris d'abord à glowupia2026@gmail.com.</P>
    </Shell>
);

export const Confidentialite = () => (
    <Shell title="Confidentialité" testId="page-confidentialite">
        <Small>Politique de confidentialité
Dernière mise à jour : 27 septembre 2026</Small>
        <H>1. Qui est responsable ?</H>
        <P>La personne indiquée dans les Mentions légales. Contact : glowupia2026@gmail.com.</P>
        <H>2. Données collectées</H>
        <P>{`- Ton prénom et tes réponses au questionnaire.
- Ta ou tes photos.
- Ton adresse e-mail.
- Tes analyses, tes plans et tes échanges avec Mike.
- Ton abonnement et tes achats. Tes données bancaires sont traitées par Stripe : nous n'y avons jamais accès.
- Ton pays de connexion, déduit de ton adresse IP (seul le pays est conservé).
- Si tu l'acceptes : tes données de navigation, via Google Analytics et Microsoft Clarity.`}</P>
        <H>3. Pourquoi</H>
        <P>{`- Fournir le service (analyse, coach, compte) : exécution du contrat.
- Gérer les paiements et la comptabilité : contrat et obligations légales.
- Mesurer l'audience du site : ton consentement.
- Assurer la sécurité et éviter les abus : notre intérêt légitime.`}</P>
        <H>4. Tes photos</H>
        <P>Elles servent uniquement à générer ton analyse. Elles ne sont jamais vendues, ni utilisées pour de la publicité ou de la reconnaissance faciale.</P>
        <H>5. Qui reçoit tes données</H>
        <P>Uniquement nos prestataires, pour faire fonctionner le service : hébergement (Emergent), paiement (Stripe), intelligence artificielle (analyse et coach), et mesure d'audience (Google, Microsoft) si tu l'acceptes. Certains peuvent traiter des données hors de l'Union européenne, avec les garanties prévues par le RGPD. Nous ne vendons aucune donnée.</P>
        <H>6. Durée de conservation</H>
        <P>Ton compte, tes photos et tes analyses sont conservés jusqu'à ce que tu les supprimes depuis la page Compte. Les données de facturation sont conservées pendant la durée imposée par la loi.</P>
        <H>7. Cookies</H>
        <P>Le site utilise le stockage nécessaire à son fonctionnement (session, progression). Les cookies de mesure d'audience (Google Analytics, Microsoft Clarity) ne sont activés qu'avec ton accord, que tu peux modifier à tout moment dans la page Compte.</P>
        <H>8. Tes droits</H>
        <P>Tu peux accéder à tes données, les corriger, les supprimer, en limiter l'usage, t'opposer à leur traitement, les récupérer et retirer ton consentement à tout moment : écris à glowupia2026@gmail.com. Tu peux aussi porter plainte auprès de l'autorité de protection des données de ton pays (en Belgique : l'Autorité de protection des données ; en France : la CNIL).</P>
    </Shell>
);
